export default __webpack_public_path__ + "static/media/mor-chalutz.b786d149.png";